// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentDetailsPopup-module__grid___McynY {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px 20px;
}
.AppointmentDetailsPopup-module__grid___McynY:first-child {
  padding-top: 0;
}

.AppointmentDetailsPopup-module__width75___to2V2 {
  grid-column: span 1;
}`, "",{"version":3,"sources":["webpack://./src/popups/AppointmentDetailsPopup/AppointmentDetailsPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,kBAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,mBAAA;AAAF","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  padding: 16px 20px;\n\n  &:first-child {\n    padding-top: 0;\n  }\n}\n\n.width75 {\n  grid-column: span 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `AppointmentDetailsPopup-module__grid___McynY`,
	"width75": `AppointmentDetailsPopup-module__width75___to2V2`
};
module.exports = ___CSS_LOADER_EXPORT___;
